<div class="kp-card d-flex">
  <div class="px-1 border-left">
    <label>
      <div>ثبت اتوماتیک</div>
      <button (confirm)="load(true)">شروع</button>
    </label>
  </div>
  <div class="px-1 border-left">
    <label>
      <span>فیلتر</span>
      <select [(ngModel)]="isRegistered" (change)="reload()">
        <option [ngValue]="null">همه</option>
        <option [ngValue]="false">ثبت نشده‌ها</option>
        <option [ngValue]="true">ثبت شده‌ها</option>
      </select>
    </label>
  </div>
  <div class="px-1 border-left">
    <label>
      <div>بستن تراکنش‌های باز</div>
      <button (confirm)="lock()">اجرا</button>
    </label>
  </div>
  <!-- <div class="px-1 border-left">
    <label>
      <span>آپلود صورت حساب</span>
      <input type="file" (change)="upload($event.target.files[0])" />
    </label>
  </div> -->
  <div *ngFor="let hesabfa of balance?.hesabfa" class="mr-auto fw-bold text-left">
    <div>مانده بانک: {{balance.bank[bankCodes[hesabfa.Code]]|number}} ریال</div>
    <div [class.f-red]="balance.bank[bankCodes[hesabfa.Code]]!=hesabfa.Balance">
      تراز حساب: {{hesabfa.Balance|number}} ریال
    </div>
  </div>
</div>

<div *ngFor="let record of records; let i=index" class="kp-card" [attr.record-id]="record.Id">
  <div class="d-flex justify-content-between fw-bold">
    <div class="d-flex">
      <div class="fs-xs ml-1">[{{record.Bank}}]</div>
      <div dir="ltr">{{record.TimeStamp|pdate:'[yyyy]/[mm]/[dd] [hh]:[MM]'}}</div>
      <i *ngIf="!record.AccountingTimeStamp" class="fa fa-clock"
        (click)="record.AccountingTimeStamp=record.TimeStamp"></i>
    </div>
    <div class="d-flex" *ngIf="record.AccountingTimeStamp">
      <i class="fa fa-trash" (click)="record.AccountingTimeStamp=null"></i>
      <app-calendar mode="year-month-day-time" [(ngModel)]="record.AccountingTimeStamp"></app-calendar>
    </div>
    <div>مبلغ: {{record.Amount|number}} ريال</div>
    <div class="pointer" (click)="record.Title=record.Description">{{record.Description}}</div>
    <div class="pointer" (click)="record.Title=record.BeneficiaryText">{{record.BeneficiaryText}}</div>
    <div class="pointer" (click)="record.Title=record.Beneficiary.Name">{{record.Beneficiary?.Name}}</div>
    <div>مانده: {{record.Balance|number}} ریال</div>
  </div>

  <ng-container *ngIf="record.RegNumber">
    سند ذخیره شده: {{record.RegNumber}}
    <button class="mx-1" (click)="unverify(record.Id)">حذف سند</button>
    <button class="mx-1" (click)="unverify(record.Id, true)">حذف سند (force)</button>
    <!-- <button class="mx-1" (click)="update(record.Id)">باز تولید سند</button> -->
  </ng-container>

  <ng-container *ngIf="!record.RegNumber && !i">

    <form class="kp-card" #form="ngForm">

      <div class="d-flex justify-content-between my-1 py-1 border-top border-bottom">
        <div>انتخاب پیشفرض:</div>
        <div *ngFor="let shortcut of shortcuts">
          <button *ngIf="!shortcut.show || shortcut.show(record)" class="btn-sm mx-1"
            (click)="setAccount(shortcut)">{{shortcut.title}}</button>
        </div>
        <div class="flex-fill">&nbsp;</div>
        <div>
          <select name="beneficiary" [(ngModel)]="record.Beneficiary" (ngModelChange)="setBeneficiary($event)">
            <option [ngValue]="null">انتخاب طرف حساب</option>
            <option *ngFor="let beneficiary of beneficiaries" [ngValue]="beneficiary">
              {{beneficiary.Name}}
            </option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="!paymentSelected">
        <label>
          <span>عنوان سند</span>
          <input name="title" [(ngModel)]="record.Title" />
        </label>
        <label>
          <span>حساب</span>
          <ng-select name="account" [items]="accounts" [(ngModel)]="record.Account" bindLabel="FullPath"
            [required]="record.Beneficiary||undefined">
            <ng-template ng-option-tmp let-item="item">
              {{item.FullPath}}
            </ng-template>
          </ng-select>
        </label>
        <label>
          <span>طرف حساب</span>
          <ng-select name="contact" [items]="personel" [(ngModel)]="record.Contact" bindLabel="Name">
            <ng-template ng-option-tmp let-item="item">
              {{item.Code}}: {{item.Name}}
            </ng-template>
          </ng-select>
        </label>
        <label>
          <span>عوارض یا درصد مالیات</span>
          <input type="number" name="fee" [(ngModel)]="record.Fee" />
        </label>
      </ng-container>

      <button class="mx-1" (click)="match(true)"><i class="fa fa-credit-card ml-1"></i>
        افزایش بازه جستجوی پرداخت‌ها</button>
      <button class="mx-1" (click)="addExtraPayment(record)"><i class="fa fa-plus ml-1"></i>
        ایجاد آرتیکل</button>

      <div *ngIf="payments || extraPayments">
        <div class="d-flex fw-bold fs-lg justify-content-between">
          <div [class.f-red]="record.BeneficiaryAmount-sum!=0">
            مغایرت: {{(record.BeneficiaryAmount-sum)|number}} ريال
          </div>
          <div>انتخاب‌ها: {{sum|number}} ريال</div>
          <div>مورد نیاز: {{record.BeneficiaryAmount|number}} ريال</div>
        </div>

        <table class="table table-bordered table-striped table-hover table-condensed table-sm overflow-scroll">
          <thead>
            <tr>
              <th (click)="select()">انتخاب</th>
              <th>زمان</th>
              <th>مبلغ</th>
              <th>موبایل</th>
              <th>شناسه</th>
              <th>عنوان</th>
              <th>توضیحات</th>
              <th>درگاه</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let payment of extraPayments">
              <td><input type="checkbox" [(ngModel)]="payment._selected" /></td>
              <td></td>
              <td>{{payment.Amount*10|number}} ريال</td>
              <td></td>
              <td></td>
              <td>{{payment.Description}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr *ngFor="let payment of payments">
              <td (mouseenter)="$event.ctrlKey && payment._selected=!payment._selected"><input [name]="payment.Id"
                  type="checkbox" [(ngModel)]="payment._selected" /></td>
              <td dir="ltr" class="text-left">{{payment.CreateTime|pdate:'[yyyy]/[mm]/[dd] [hh]:[MM]'}}</td>
              <td>{{payment.Amount*10|number}} ريال</td>
              <td>{{payment.Mobile}}</td>
              <td>{{payment.Token}}</td>
              <td>{{payment.Description}}</td>
              <td [ngSwitch]="payment.ItemType">
                <div *ngSwitchCase="0">-</div>
                <div *ngSwitchCase="1">افزایش بودجه</div>
                <div *ngSwitchCase="2">بودجه آگهی</div>
                <div *ngSwitchCase="3">پیشتاز کردن کارجو</div>
                <div *ngSwitchCase="4">خرید رزومه</div>
                <div *ngSwitchCase="5">خرید فایل</div>
                <div *ngSwitchCase="6">افزایش بودجه آگهی</div>
                <div *ngSwitchCase="7">کارپاشا</div>
                <div *ngSwitchCase="8">کاریار</div>
                <div *ngSwitchCase="9">ثبت نام کاریابی</div>
                <div *ngSwitchCase="10">تعرفه کاریابی</div>
              </td>
              <td [ngSwitch]="payment.Provider">
                <div *ngSwitchCase="1">پرداخت پی</div>
                <div *ngSwitchCase="2">زرین پال</div>
                <div *ngSwitchCase="3">پی پینگ</div>
                <div *ngSwitchCase="5">به پرداخت</div>
                <div *ngSwitchCase="6">سپ</div>
                <div *ngSwitchCase="4">کارت به کارت</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button class="mx-1" [class.fade-red-bg]="!record._balanced" [class.light-green-bg]="record._balanced"
        (click)="form.valid && verify()">ذخیره سند</button>
    </form>

  </ng-container>

  <ng-container *ngIf="!record.RegNumber && i">
    <label>
      <input type="checkbox" [(ngModel)]="record._selected" />
      <span>مکمل سند اول است</span>
    </label>
  </ng-container>

</div>

<button *ngIf="records?.length<total" (click)="loadMore()">بیشتر</button>

<ngx-smart-modal #ExtraPaymentModal identifier="ExtraPaymentModal">
  <div *ngIf="extraPayment && ExtraPaymentModal.visible"
    class="d-flex flex-column container-capped-sm f-initial text-right py-2">
    <div class="border-bottom mb-3">
      <div class="text-center fw-bold fs-lg">ثبت آرتیکل</div>
    </div>
    <div class="mb-2 pb-2">
      <div class="h6">مبلغ</div>
      <div class="text-left">
        <input type="number" [(ngModel)]="extraPayment.Amount" />
      </div>
    </div>
    <div class="mb-2 pb-2">
      <div class="h6">توضیحات</div>
      <div class="text-left ">
        <input type="text" [(ngModel)]="extraPayment.Description" />
      </div>
    </div>
    <div class="text-left">
      <button class="btn btn-primary my-2"
        (click)="extraPayments?.splice(0, 0, extraPayment);ExtraPaymentModal.close()">ثبت</button>
    </div>
  </div>
</ngx-smart-modal>